'use client';

import { overlay } from 'overlay-kit';
import AlertModal from '@/app/cc/_component/ui/common/AlertModal/AlertModal';
export function useAlertModal() {
  return (message: string) => {
    overlay.open(({
      isOpen,
      close
    }) => <AlertModal message={message} isOpen={isOpen} onClose={close} />);
  };
}